import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

const { Form } = Common;

const NotificationConfigFormElements = ({
  errors,
  handleValueChange,
  handleRemoveCustomField,
  handleAddCustomField,
  isSubmitted,
  notifications_elementsBySections,
  allSections,
  handleCheckSection, ///
  handleClickPermissionRow, ///
  handleCheckPermission, ///
  t,
  values,
}) => {
  let { customFields = [] } = values;
  let visibles = customFields.filter((c) => !c.deleted);
  const section = 'notifications_config';

  return (
    <div className="col-12">
      {allSections.map((section) => (
        <Form.Section title={t('notification_config.form.customFields')}>
          <div className="table-responsive mb-4">
            <h5 className="mb-3">{t(`${section}.title`)}</h5>
            <table className="table table-striped table-hover">
              <thead>
                <tr>
                  <th width="5%">
                    <Form.Checkbox
                      className="icheckbox_flat-green"
                      value={section}
                      onChange={handleCheckSection}
                    />
                  </th>
                  <th>{t('notification_config.description')}</th>
                  <th width="20%">{t('notification_config.key')}</th>
                </tr>
              </thead>
              <tbody>
                {notifications_elementsBySections[section].map((element) => (
                  <tr
                    onClick={(e) => handleClickPermissionRow(e, element)}
                    style={{ cursor: 'pointer' }}
                  >
                    <td>
                      <Form.Checkbox
                        className="icheckbox_flat-blue"
                        value={element}
                        onChange={handleCheckPermission}
                        checked={values.elements.indexOf(element) > -1}
                      />
                    </td>
                    <td>{t(element)}</td>
                    <td>{element}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Form.Section>
      ))}
    </div>
  );
};

export default translate()(NotificationConfigFormElements);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/components/form/sections/NotificationConfigFormElements.js